import { render } from "./edit_product_comment.vue?vue&type=template&id=23bb9ef2&scoped=true"
import script from "./edit_product_comment.vue?vue&type=script&lang=js"
export * from "./edit_product_comment.vue?vue&type=script&lang=js"

import "./edit_product_comment.vue?vue&type=style&index=0&id=23bb9ef2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bb9ef2"]])

export default __exports__